import React from "react";

interface GuidePopupProps {
  title: string;
  className?: string;
  isReverse?: boolean;
  children?: React.ReactNode;
}

const GuidePopup = ({
  title,
  className,
  isReverse,
  children,
}: GuidePopupProps) => {
  return (
    <div className={`${className} h-auto mb-[60px]`}>
      {!isReverse ? (
        <div className="relative w-[265px] ml-[73px] top-[0px] bg-black border border-white rounded-tl-[16px] rounded-tr-[16px] rounded-br-[16px] rounded-bl-none box-border p-[19px] text-white text-[15px] sl:text-[19px]">
          {title}
          {children && <div>{children}</div>}
          <div className="absolute bottom-[-45px] left-[-70px] w-[66px] h-[66px] ">
            <img src="/assets/guide.gif" alt="guide-popup" />
          </div>
        </div>
      ) : (
        <div className="relative w-[265px]  bg-black border border-white rounded-tl-[16px] rounded-tr-[16px] rounded-bl-[16px] rounded-br-none box-border p-[19px] text-white text-[19px]">
          {title}
          <div className="absolute bottom-[-45px] right-[-70px] w-[66px] h-[66px] ">
            <img src="/assets/guide.gif" alt="guide-popup" />
          </div>
        </div>
      )}
    </div>
  );
};

export default GuidePopup;
